var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCovidStaff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.889l1.333 1.777-1.333 8h4.444l-1.333-8 1.333-1.777h2.845c2.044 0 4.489 2 4.844 4.71l.756 5.068H3.556L4.31 21.6c.356-2.711 2.8-4.711 4.845-4.711H12z",
    fill: "#EDF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.703 18.882c-.78.717-1.363 1.711-1.51 2.833l-.002.016-.604 3.158h19.27l-.602-3.158a.97.97 0 01-.004-.03c-.128-1.111-.706-2.1-1.49-2.818-.793-.726-1.722-1.105-2.472-1.105a.889.889 0 010-1.778c1.295 0 2.633.62 3.673 1.572 1.046.958 1.866 2.318 2.053 3.911l.753 4.164a.889.889 0 01-.879 1.02H3.556a.889.889 0 01-.88-1.02l.755-4.17c.21-1.586 1.026-2.944 2.067-3.903C6.532 16.622 7.86 16 9.156 16a.889.889 0 110 1.778c-.748 0-1.664.377-2.453 1.104z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.778 22.667h-3.11c-.268 0-.445-.178-.445-.445v-.889c0-.266.177-.444.444-.444h3.111c.267 0 .445.178.445.444v.89c0 .266-.178.444-.445.444zM12.711 17.244a.889.889 0 00-1.422 1.067l1.1 1.466-1.278 6.89h1.778l1.198-6.223h.271l1.198 6.223h1.778l-1.278-6.89 1.1-1.466a.889.889 0 10-1.422-1.067l-1.067 1.423h-.889l-1.067-1.423z",
    fill: props.color
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89 3.555c0-.981.795-1.777 1.777-1.777h7.111c.982 0 1.778.796 1.778 1.777v2.667c0 .491-.398.889-.89.889H9.779a.889.889 0 01-.889-.889V3.555z",
    fill: "#EDF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89 3.555c0-.981.795-1.777 1.777-1.777h7.111c.982 0 1.778.796 1.778 1.777v2.667a.89.89 0 01-.044.277 6.222 6.222 0 11-10.579 0 .888.888 0 01-.044-.277V3.555zm1.777 0h7.111v1.778h-7.11V3.555zm0 3.556a4.444 4.444 0 107.112 0h-7.112z",
    fill: props.color
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.29 20.489a6.224 6.224 0 00-10.622 4.4 6.222 6.222 0 1010.621-4.4z",
    fill: "#54822B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.555 27.999l-2.471-2.472 1.256-1.257 1.215 1.215 3.664-3.662 1.256 1.256-4.92 4.92z",
    fill: "#fff"
  })));
}

export default SvgIconCovidStaff;